import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      text: "Tesla's Academy has been instrumental in my daughter's academic success. The teachers are dedicated and the personalized attention has made a huge difference. She scored 98% in her board exams!",
      author: "Mrs. Priya Sharma",
      role: "Parent of Grade X Student"
    },
    {
      text: "The faculty at Tesla's Academy truly understands how to make complex concepts simple. My son's confidence and grades have improved tremendously. Best decision we made for his education!",
      author: "Mr. Rajesh Kumar",
      role: "Parent of Grade VIII Student"
    },
    {
      text: "As an IGCSE student, I needed specialized guidance. Tesla's Academy provided exactly that with their experienced teachers and comprehensive study materials. Highly recommended!",
      author: "Aishwarya Menon",
      role: "Grade XI IGCSE Student"
    }
  ];

  return (
    <section id="testimonials">
      <div className="section-header">
        <h2 className="section-title">What Parents Say</h2>
        <p className="section-subtitle">
          Hear from our satisfied parents and students
        </p>
      </div>
      <div className="testimonials-slider">
        {testimonials.map((testimonial, index) => (
          <div key={index} className="testimonial-card">
            <div className="quote-icon">"</div>
            <p className="testimonial-text">{testimonial.text}</p>
            <div className="testimonial-author">{testimonial.author}</div>
            <div className="testimonial-role">{testimonial.role}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
